var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.perPage),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"skeleton-td",attrs:{"colspan":_vm.columnCount}},[_c('v-skeleton-loader',{attrs:{"type":"list-item, divider"}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }